import { useEffect } from 'react';

/**
 * useStripAutoReloadParam
 *
 * One-shot effect that silently removes the `?autoreload=true` query param
 * that the auto-reload path in the inline PWA update script (index.html)
 * adds before navigating.
 *
 * Runs once on mount.  Uses replaceState so the removal doesn't create a
 * history entry and doesn't trigger a re-render or route change.
 * No toast, no log — invisible to the user (Asana-style).
 */
export function useStripAutoReloadParam(): void {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('autoreload') === 'true') {
      params.delete('autoreload');
      const newSearch = params.toString();
      const newUrl =
        window.location.pathname +
        (newSearch ? `?${newSearch}` : '') +
        window.location.hash;
      window.history.replaceState(null, '', newUrl);
    }
  }, []);
}
